<table>
    <thead>
        <tr>
            <th>{{'global.modoCertificado' | translate}}</th>
            <th>{{'global.modoEtiqueta' | translate}}</th>
            <th class="actions">{{'gestionLicencias.parametros.table.tabs.grupoEtiquetasDeno.acciones' | translate}}</th>
        </tr>
    </thead>
    <tbody>
        <app-new-edit-param-certificado class="component-in-row" [modoCertificado]="certificado.modoCertificado" [modoEtiquetas]="certificado.modoEtiquetas" [paisId]="paisId" [denominacionId]="denominacionId" [almacenId]="almacenId" [licenciaSwId]="licenciaSwId" (refresh)="toRefresh($event)" (editableChanged)="editableChanged($event)"></app-new-edit-param-certificado>
    </tbody>
    <tfoot *ngIf="(!certificado || certificado.length < 1) || (!certificado || certificado.length < 1) ">
        <tr>
            <td colspan="6">
                {{ 'global.noContent' | translate }}
            </td>
        </tr>
    </tfoot>
</table>